module.exports = __webpack_public_path__ + "static/fonts/manrope-extrabold.046b1d96.woff2";